import React from "react";
import styles from "./DietPreferenceDisplay.module.css";
import { DietType } from "./DietTypeFilter";

interface DietPreferenceDisplayProps {
  detectedDietTypes: DietType[];
  searchQuery: string;
}

const DietPreferenceDisplay: React.FC<DietPreferenceDisplayProps> = ({
  detectedDietTypes,
  searchQuery,
}) => {
  if (!detectedDietTypes.length || !searchQuery) {
    return null;
  }

  const getDietTypeLabel = (dietType: DietType): string => {
    switch (dietType) {
      case "vegan":
        return "Vegan";
      case "vegetarisch":
        return "Vegetarian";
      case "glutenfrei":
        return "Gluten Free";
      default:
        return dietType;
    }
  };

  return (
    <div className={styles.dietPreferenceDisplay}>
      <div className={styles.header}>
        <span className={styles.icon}>🎯</span>
        <span className={styles.title}>Detected Preferences</span>
      </div>
      <div className={styles.content}>
        <div className={styles.query}>
          <strong>Search:</strong> "{searchQuery}"
        </div>
        <div className={styles.preferences}>
          <strong>Applied filters:</strong>
          <div className={styles.tags}>
            {detectedDietTypes.map((dietType) => (
              <span key={dietType} className={styles.tag}>
                {getDietTypeLabel(dietType)}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DietPreferenceDisplay;
